import { describe_error } from '../utils/ErrorDescriber';
// components/SideMenu.js (final version with integrated App.css classes)

import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

import Constants from '../Constants';
import { useAuth } from '../AuthContext';
import '../App.css';

import wordmark from '../assets/menu-wordmark.jpg';

import dashboard from '../assets/dashboard-icon.jpg';

// The help page the Help link opens.
const c_HelpIntroductionPath = '/help/introduction';

// The addresses each menu link covers, so the link of the screen on show is bold: a path matches itself exactly, a
// path ending in '/' matches everything under it. Sites covers a site's analysis, dashboard and page screens.
const c_MenuLinkPaths = {
	'/aeo_analysis': ['/aeo_analysis', '/'],
	'/sites': ['/sites', '/site/', '/site-page/'],
	'/chat': ['/chat'],
	'/feedbackform': ['/feedbackform'],
	'/profile': ['/profile'],
	'/superadmin': ['/superadmin', '/superadmin/']
};

function SideMenu() {
	const { token, is_superadmin, logout } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	// The menu shows the help pages while the user is reading help: from the Help link, or on arriving at a help
	// page's address. Close puts the normal menu back.
	const [show_help, set_show_help] = useState(location.pathname.startsWith('/help'));
	const [help_pages, set_help_pages] = useState([]);
	const [help_loading, set_help_loading] = useState(false);

	// The AuthContext's logout, as Lead Barbarian's: the token revoked on the server, the login cleared, the login
	// screen opened
	const handle_logout=()=>{
		logout();
	}

	const load_help_pages = async()=>{
		set_help_loading(true);

		try {
			const response = await axios.get(Constants.SERVER_URL + '/api/help_pages', { headers: { Authorization: 'Bearer ' + token } });
			set_help_pages(response.data.pages);
		} catch (error) {
			console.log('SideMenu/load_help_pages - ERROR: ', describe_error(error));
		}

		set_help_loading(false);
	};

	const handle_help_open = ()=>{
		if(help_pages.length === 0){
			load_help_pages();
		}

		set_show_help(true);
		navigate(c_HelpIntroductionPath);
	};

	const handle_help_close = ()=>{
		set_show_help(false);
	};

	// A page arrived at by address opens the help menu without the Help link, so its pages are loaded here.
	useEffect(()=>{
		if(show_help && (help_pages.length === 0)){
			load_help_pages();
		}
	}, []);

	// Whether the screen on show belongs to the menu link to link (see c_MenuLinkPaths).
	const is_active_link = (link)=>{
		const paths = c_MenuLinkPaths[link];
		if(!paths){
			return false;
		}

		return paths.some((path)=>{
			if(path.endsWith('/') && (path !== '/')){
				return location.pathname.startsWith(path);
			}

			return location.pathname === path;
		});
	};

	const render_menu_link = (label, link,  icon)=>{
		return <li>
					<span className='sidebar-link-container'>
						<Link className={'sidebar-link' + (is_active_link(link) ? ' sidebar-link-active' : '')} to={link}>{label}</Link>
					</span>
				</li>;
	}


	// <li><Link className="sidebar-link" to="/profile">Profile</Link></li>
	// <li><Link className="sidebar-link" to="/deal_calculator">Deal Calculator</Link></li>
	// <li><Link className="sidebar-link" to="/plans">Plans</Link></li>
	// <li><Link className="sidebar-link" to="/post-generator">Post Generator</Link></li>

	{render_menu_link('Dashboard', '/', dashboard)}

	const render_normal_menu = ()=>{
		return (
			<React.Fragment>
				{render_menu_link('AEO Analysis', '/aeo_analysis', dashboard)}
				{render_menu_link('Sites', '/sites', dashboard)}
				{render_menu_link('AEO Assistant', '/chat', dashboard)}
				{render_menu_link('Feedback', '/feedbackform', dashboard)}
				{render_menu_link('Account', '/profile', dashboard)}
				{is_superadmin && render_menu_link('SuperAdmin', '/superadmin', dashboard)}
				<li>
					<span className="sidebar-link-container">
						<button className="sidebar-link sidebar-link-button" onClick={handle_help_open}>
							Help
						</button>
					</span>
				</li>
			</React.Fragment>
		);
	};

	const render_help_page_link = (page)=>{
		return (
			<li key={page.id}>
				<span className="sidebar-link-container">
					<NavLink
						className={({ isActive })=>{ return 'sidebar-link' + (isActive ? ' sidebar-link-active' : ''); }}
						to={'/help/' + page.key}
					>
						{page.title}
					</NavLink>
				</span>
			</li>
		);
	};

	const render_help_menu = ()=>{
		return (
			<React.Fragment>
				<li className="sidebar-help-heading">
					<span className="sidebar-help-title">Help</span>
				</li>
				{help_loading ? (
					<li className="sidebar-help-loading">Loading...</li>
				) : help_pages.map(render_help_page_link)}
				<li className="sidebar-help-close">
					<span className="sidebar-link-container">
						<button className="sidebar-link sidebar-link-button" onClick={handle_help_close}>
							Close
						</button>
					</span>
				</li>
			</React.Fragment>
		);
	};

	return (
		<div className="sidebar">
			<ul className="sidebar-menu">
				{show_help ? render_help_menu() : render_normal_menu()}
			</ul>
		</div>
	);
}

export default SideMenu;

/*
<li><Link className="sidebar-link" to="/post-generator">Post Generator</Link></li>
<li><Link className="sidebar-link" to="/">Dashboard</Link></li>
<li><Link className="sidebar-link" to="/plans">Plans</Link></li>
<li><Link className="sidebar-link" to="/profile">Profile</Link></li>
<li><Link className="sidebar-link" to="/deal_calculator">Deal Calculator</Link></li>
*/
